import { Link, useLocation } from "react-router-dom";
import "../Myprojects.css"; 
import { jwtDecode } from "jwt-decode";
import React, { useState } from "react";
import physics from "../../../../assets/img/myProjects/physics.jpg"
import biolo from "../../../../assets/img/myProjects/biolo.png"
import elseo from "../../../../assets/img/myProjects/elseo.jpg"
import math from "../../../../assets/img/myProjects/math.jpg"
import { FiEdit } from "react-icons/fi";
import api from "views/auth/Api";
import { API_BASE_URL } from '../../../../configs/AppConfig';


const Header = ({current, change, title, subject, proId , team , active ,action , isloading }) => {
    const [headerImage , setHeaderImage] = useState([]);
    const token = localStorage.getItem('token');
    const decoded = jwtDecode(token);
    const role = decoded.role
    // const current = prop?.current

    let location = useLocation();
    // const overview = location.pathname.includes("overview");
    // const resources = location.pathname.includes("resources");
    // const submission = location.pathname.includes("submission");
    // const feedback = location.pathname.includes("feedback");
    // const model3d = location.pathname.includes("3dmodel");
    const assign = location.pathname.includes("assign");

        // if(subject==="Physical Science") {
        //     setHeaderImage(headerImg);
        // }
  const toggleStatus = async () => {
    await api.patch(`${API_BASE_URL}projects/${proId}`,{
      isActive: !active
    })
    .then((response) => {
      action(response.data.isActive);
    })
    .catch((error) => {
      console.error('Error updating status:', error);
    });
  };

  const headerImages =() => {
    if(subject==="Physical Science") {
      return (
        <div className="headerImg" style={{ backgroundImage: `url(${physics})` }}></div>
      );
    }
  else if(subject==="Science") {
          return (
        <div className="headerImg" style={{ backgroundImage: `url(${biolo})` }}></div>
      );
  }
  else if(subject==="Mathematics") {
          return (
        <div className="headerImg" style={{ backgroundImage: `url(${math})` }}></div>
      );
  }
  else {
      return (
        <div className="headerImg" style={{ backgroundImage: `url(${elseo})` }}></div>
      );    
  }
}
  return (
    <div>
    <div
      className="projectsHeader">
     {headerImages()}      
      <div className="w-full headerInfo">
        <h1 className="headerH1">
          {title}
        </h1>
        <div className="headerLinks mt-[40px]">
        <div className="headerLink" onClick={() => change("overview")} > <span className={current==="overview" ? "active" : "noActive"}>overview</span>
        </div>
        <div className="headerLink" onClick={() => change("details")} > <span className={current==="details" ? "active" : "noActive"}>details</span>
        </div>
        <div className="headerLink" onClick={() => change("resources")} > <span className={current==="resources" ? "active" : "noActive"}  > resources </span>
        </div>
        <div className="headerLink" onClick={() => change("model3d")} > <span className={current==="submission" || current==="model3d" ? "active" : "noActive"}  > {role==="Teacher" || role==="Admin" ? "3D Models": "submission"} </span>
        </div>
        {role==="Admin" || !assign & role==="Teacher" ?  null :  <div className="headerLink" onClick={() => change("subFeed")} > <span className={current==="feedback" || current==="subFeed" ? "active" : "noActive"}  > {role==="Teacher" ? "Submission & Feedback": "feedback"} </span>
        </div>}
          </div> 
      </div>
      {role === "Student" ? <div className="teamSizeArmor">
        <div className="teamSizeInfo">
        <span className="teamSizeInfos1">TEAM</span> 
        <span className="teamSizeInfos2">{team}</span>
 </div>
      </div> : null}

    </div>
    {role === "Admin" && isloading === true ? <div className="flex flex-row justify-between mb-[20px]"> <div className="flex flex-row gap-[10px]"> <Link to={`/admin/tr/projects/edit/${proId}`} ><div className="newChallenge w-[167px]">
             <FiEdit className="addImg"/>
             <span>Details</span>
           </div></Link> 
           <Link to={`/admin/tr/projects/editresources/${proId}`} ><div className="newChallenge w-[167px]">
             <FiEdit className="addImg"/>
             <span>Resources</span>
           </div></Link>
           <Link to={`/admin/tr/projects/editquiz/${proId}`} ><div className="newChallenge w-[167px]">
             <FiEdit className="addImg"/>
             <span>MCQ Quiz </span>
           </div></Link> </div>  <span onClick={toggleStatus} className={`inline-flex items-center justify-center text-[18px] font-semibold rounded-[8px] w-[90px] cursor-pointer text-white ${
          active ? "bg-green-500" : "bg-red-500"
        }`}>{active ? "Active" : "Inactive"}</span>
        </div> : null}
    </div>
  );
};

export default Header;
